import { makeAutoObservable } from "mobx";
import { ContextMenuOption } from "../components/ContextMenu/ContextMenu";

interface ContextMenuPosition {
  x: number;
  y: number;
}

class ContextMenuStoreInstance {
  position: ContextMenuPosition | null = null;
  options: ContextMenuOption[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  show(x: number, y: number, options: ContextMenuOption[]) {
    this.position = { x, y };
    this.options = options;
  }

  hide() {
    this.position = null;
  }

  reset() {
    this.position = null;
    this.options = [];
  }
}

const ContextMenuStore = new ContextMenuStoreInstance();

export { ContextMenuStore };
